import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SrubUpService } from '../Services/ScrubUp.service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { MatSnackBar } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss'],
  providers: [SrubUpService]
})
export class SubscriptionComponent implements OnInit {

  loading = false;
  isImpersonateMode = false;
  displayedColumns: string[] = ['planName', 'planDetails', 'action'];
  subscriptionPlans: any[] = [];

  constructor(
    private router: Router,
    private scrubUpService: SrubUpService,
    private appWideUser: AppWideUser,
    private token: Token,
    private cookieService: CookieService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    // Check if user is logged in
    if (this.token.access_token == undefined || this.token.access_token == null) {
      if (this.cookieService.check('Token')) {
        this.token = JSON.parse(this.cookieService.get('Token'));
      } else {
        this.router.navigate(['/login']);
        return;
      }
    }

    // Check if impersonation mode is active
    if (this.cookieService.check('impersonation')) {
      this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    }

    // Load subscription plans
    this.loadSubscriptionPlans();
  }

  loadSubscriptionPlans() {
    this.loading = true;
    this.scrubUpService.getPackageTypesList(this.token)
      .subscribe(
        (response) => {
          // Check if response has Data property (common API response pattern)
          if (response && response.Data && Array.isArray(response.Data)) {
            this.subscriptionPlans = response.Data.map(plan => ({
              id: plan.PackageTypeID,
              name: plan.PackageTypeName,
              details: plan.Description || 'No description available',
              price: plan.Price || 0
            }));
          } else if (response && Array.isArray(response)) {
            // Fallback to direct array response
            this.subscriptionPlans = response.map(plan => ({
              id: plan.PackageTypeID,
              name: plan.PackageTypeName,
              details: plan.Description || 'No description available',
              price: plan.Price || 0
            }));
          } else {
            console.error('Unexpected API response format:', response);
            this.snackBar.open('Unexpected data format from API', 'Close', {
              duration: 3000,
            });
          }
          this.loading = false;
        },
        (error) => {
          console.error('Error loading subscription plans:', error);
          this.loading = false;
          this.snackBar.open('Failed to load subscription plans', 'Close', {
            duration: 3000,
          });
        }
      );
  }

  editSubscription(plan: any) {
    this.router.navigate(['/layout/subscription/edit', plan.id], { queryParams: { name: plan.name } });
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/subscription/subscription.component.ts